import classNames from 'classnames';
import * as React from 'react';

import css from './BooksLabel.module.scss';

interface Props {
  className?: string;
  label: string;
}

const BooksLabel = ({ className, label }: Props) => {
  const classes = classNames(css.BooksLabel, className);

  return <span className={classes}>{label}</span>;
};

export default BooksLabel;
